/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

import { AuthService } from './auth.service';

//https://medium.com/interoperable/using-httpinterceptor-to-add-a-bearer-token-to-api-calls-with-ng-oidc-client-6b088d680e73
//https://blog.briebug.com/blog/3-ways-to-use-angular-http-interceptor
//https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/
//https://indepth.dev/tutorials/angular/authentication-token-interceptor
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  //https://stackoverflow.com/questions/45355763/angular-4-3-interceptors-how-to-use
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //return next.handle(request);

    let url: string = request.url;

    
    if (url.includes('/api/')) {

      
      //return next.handle(request);

      const token = this.authService.getAuthToken();

      if (token) {
        // If we have a token, we set it to the header
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
      }

      return next.handle(request).pipe(

        catchError((err) => {


          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              // redirect user to the logout page
            }
          }

          return throwError(() => err);
          //return throwError(err);

        })
      )


    } else {

      return next.handle(request);

    }




  }

}
